import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ContentCopyOutlined, DeleteOutlined, EditOutlined, QrCode2Outlined, VisibilityOutlined } from '@mui/icons-material';
import { CustomWarningDelete } from '../../CustomWarningDelete';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { DuplicateSurveyForm } from './DuplicateSurveyForm';
import { UpdateSurveyForm } from './UpdateSurveyForm';
import { QrView } from './QrView';
import { useModalStore } from '../../../store/useModalStore';

export const Actions = ({ data, qr, updated, duplicated, deleted }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef: { current: { handleOpen } } } = useContext(ModalsContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'encuestas')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    // const openModal = (form) => handleOpen(form);

    const buttons = [
        { icon: <QrCode2Outlined color='action' fontSize='small' />, action: () => openModal(<QrView data={ data } action={ qr }/>) },
        { icon: <ContentCopyOutlined color='action' fontSize='small' />, action: () => openModal(<DuplicateSurveyForm data={ data } action={ duplicated } />) },
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => false },
        { icon: <EditOutlined color='action' fontSize='small' />, action: () => openModal(<UpdateSurveyForm data={ data } action={ (e) => updated({...e, _id: data?._id}) }/>)  },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<CustomWarningDelete action={ () => deleted(data?._id) } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}